var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"android-tuorials-container"},_vm._l((_vm.commonTutorials),function(item){return _c('div',{key:item.id,staticClass:"item"},[_c('TutorialsItems',{attrs:{"commonTutorials":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }